<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousVendorView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Container / Vehicle Gate-In Form</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- <md-layout md-gutter class="marg-top">
          <md-layout md-flex="5"></md-layout>
          <h4>Container Details:</h4>
          <md-layout md-flex="30"></md-layout>
            </md-layout>-->
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label for="gateInType">Gate-In Type</label>
                  <model-list-select
                    option-value="gateTypeListV"
                    option-text="gateTypeListT"
                    :list="gateTypeList"
                    placeholder="Select Type"
                    v-model="ContainerDetail.gateInType"
                    :isDisabled="VehicleDetail.containerGateInId==''?false:true"
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!ContainerDetail.gateInType">{{gateInTypeError}}</span>
              </md-layout>
            </md-layout>
            <md-layout
              md-gutter
              class="gutr"
              v-if="ContainerDetail.gateInType=='Vehicle_With_Container'"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Container Number</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="containerNo"
                    name="containerNo"
                    v-model="ContainerDetail.containerNo"
                    :disabled="ContainerDetail.containerGateInId==''?false:true"
                    @keyup="checkContainer()"
                  ></b-form-input>
                </md-layout>
                <span class="error">{{sameContainerError}}</span>
                <span class="error" v-if="!ContainerDetail.containerNo">{{containerNoError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="45">
                <label for="containerTypeId">Container Size / Type</label>
                <model-list-select
                  option-value="containerType"
                  option-text="containerType"
                  :list="containerDetail"
                  placeholder="Select Type"
                  v-model="ContainerDetail.containerTypeId"
                ></model-list-select>

                <span class="error" v-if="!ContainerDetail.containerTypeId">{{containerTypeIdError}}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="40" v-if="ContainerDetail.gateInType!='' ">
                <label for="vehicleTruckId">Vehicle No.</label>
                <model-list-select
                  option-value="regdNo"
                  option-text="regdNo"
                  :list="vehicleMasterList"
                  placeholder="Select Vehicle"
                  v-model="ContainerDetail.otherVehicle"
                  :disabled="ContainerDetail.containerTypeId=='' && ContainerDetail.gateInType!='Empty_Vehicle'?true:false"
                ></model-list-select>

                <span class="error">{{sameVehicleError}}</span>
                <span class="error" v-if="!ContainerDetail.otherVehicle">{{otherVehicleError}}</span>
              </md-layout>
              <md-layout md-flex="5" v-if="ContainerDetail.otherVehicle=='Other Vehicle'"></md-layout>

              <md-layout md-flex="20" v-if="ContainerDetail.otherVehicle=='Other Vehicle'">
                <md-layout md-flex="100">
                  <label>Other Vehicle No.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="otherVehicle"
                    name="otherVehicle"
                    v-model="ContainerDetail.vehicleNo"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!ContainerDetail.vehicleNo">{{vehicleNoError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20" v-if="ContainerDetail.gateInType!='' ">
                <md-layout md-flex="100">
                  <label>Transporter Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="transportName"
                    name="transportName"
                    v-model="ContainerDetail.transportName"
                    :disabled="tempVehicle==ContainerDetail.otherVehicle?true:false"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!ContainerDetail.transportName">{{transportNameError}}</span>
              </md-layout>
              <md-button
                style="margin-top:18px"
                class="md-raised md-primary md-button-color heght-1px"
                id="addButtonLoader1"
                @click="addContainer"
                v-if="ContainerDetail.gateInType=='Empty_Vehicle'"
              >{{ContainerDetail.containerGateInId==''?"Add":"Edit"}} Vehicle</md-button>
            </md-layout>
            <md-layout
              md-gutter
              class="gutr"
              v-if="ContainerDetail.gateInType=='Vehicle_With_Container'"
            >
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label for="importStatus">Transport Type</label>
                  <model-list-select
                    option-value="ImpVal"
                    option-text="ImpText"
                    :list="ImpList"
                    placeholder="Select Type "
                    v-model="ContainerDetail.importStatus"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="45">
                <label for="shippingId">Shipping Line</label>
                <model-list-select
                  option-value="shippingId"
                  option-text="shippingLine"
                  :list="lineDetailMaster"
                  placeholder="Select Shipping Line "
                  v-model="ContainerDetail.shippingId"
                ></model-list-select>

                <!-- <span class="error" v-if="!ContainerDetail.shippingId">{{shippingIdError}}</span> -->
              </md-layout>
            </md-layout>
            <md-layout
              md-gutter
              v-if="ContainerDetail.gateInType=='Vehicle_With_Container'"
              class="gutr"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Gross Wgt.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="grossWeight"
                    name="grossWeight"
                    v-model="ContainerDetail.grossWeight"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!ContainerDetail.grossWeight">{{grossWeightError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Tare Wgt.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="tareWeight"
                    name="tareWeight"
                    v-model="ContainerDetail.tareWeight"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!ContainerDetail.tareWeight">{{tareWeightError}}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Mfg. Month-Yr</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="manufractureYear"
                    name="manufractureYear"
                    v-model="ContainerDetail.manufractureYear"
                  ></b-form-input>
                </md-layout>
                <span
                  class="error"
                  v-if="!ContainerDetail.manufractureYear"
                >{{manufractureYearError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label for="containerCondition">Container Condition</label>
                <model-list-select
                  option-value="containerConditionV"
                  option-text="containerConditionT"
                  :list="containerConditionList"
                  placeholder="Select"
                  v-model="ContainerDetail.containerCondition"
                ></model-list-select>
              </md-layout>
            </md-layout>
            <md-layout
              md-gutter
              class="gutr"
              v-if="ContainerDetail.gateInType=='Vehicle_With_Container'"
            >
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Arrival From</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="arrivalFrom"
                    name="arrivalFrom"
                    v-model="ContainerDetail.arrivalFrom"
                  ></b-form-input>
                </md-layout>
                <!-- <span class="error" v-if="!VehicleDetail.arrivalFrom">{{arrivalFromError}}</span> -->
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Arrival date</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="vehcleArrivalDate"
                    name="vehcleArrivalDate"
                    v-model="ContainerDetail.vehcleArrivalDate"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Do Number</label>
                  <b-form-input :formatter="capitalizeAll" id="doNumber" name="doNumber" v-model="ContainerDetail.doNumber"></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>DO Valid upto Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  v-model="ContainerDetail.bookingDate"
                  :not-before="new Date()"
                  id="bookingDate"
                ></date-picker>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="50"></md-layout>

              <md-layout md-flex="45" v-if="ContainerDetail.gateInType=='Vehicle_With_Container'">
                <md-layout md-flex="100">
                    <!-- <label></label> -->
                  <md-input-container>
                  
                    <md-file
                    placeholder="Upload Do"
                      id="transportName"
                      name="transportName"
                      v-model="ContainerDetail.uploadGateInCon"
                      @selected="onFileChange('uploadGateInCon')"
                      multiple
                    ></md-file>
                  </md-input-container>
                </md-layout>
                <span class="error" v-if="!ContainerDetail.uploadGateInCon">{{uploadGateInConError}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="85"></md-layout>

              <md-layout md-flex="15" v-if="ContainerDetail.gateInType=='Vehicle_With_Container'">
                <b-button
                  variant="info"
                  size="sm"
                  id="addButtonLoader1"
                  :disabled="maintainenceId==''?false:true"
                  @click="addContainer"
                >{{ContainerDetail.containerGateInId==''?"Add":"Edit"}} Container</b-button>
                <span
                  class="error"
                >{{(VehicleDetail.containerGateInId=='')?containerGateInIdError:""}}</span>
              </md-layout>
            </md-layout>
            <div class="box" v-if="allContainerDetail.length>0">
              <div class="box-header">
                <label class="box-title">Container Detail</label>
              </div>

              <!-- /.box-header -->
              <div class="box-body">
                <table id="gateInContainer" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Vehicle Number</th>
                      <th>Container Number</th>
                      <th>Container Size</th>
                      <th>Arrival Date</th>
                      <th v-if="maintainenceId==''">Edit</th>
                      <th v-if="maintainenceId==''">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in allContainerDetail" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{item.vehicleNo }}</td>
                      <td>{{(item.containerNo=='')?"-":item.containerNo}}</td>
                      <td>{{(item.containerTypeId=='')?"-":item.containerTypeId}}</td>
                      <td>{{item.loginTime | moment}}</td>
                      <td v-if="maintainenceId==''">
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="viewModalPage(item.containerGateInId)"
                        >
                          <md-icon>edit</md-icon>
                        </md-button>
                      </td>

                      <td v-if="maintainenceId==''">
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="deleteData(item.containerGateInId)"
                          :disabled="(serviceDetails.approvedStatus=='Sent For Approval')"
                        >
                          <md-icon>delete_sweep</md-icon>
                        </md-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>

            <div v-if="ContainerDetail.gateInType=='Vehicle_With_Container'">
              <md-layout md-gutter class="gutr">
                <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Shipper Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="shipperName"
                  name="shipperName"
                  v-model="VehicleDetail.shipperName"
                ></b-form-input>
              </md-layout>
                </md-layout>-->
                <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Transporter Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="gateInTransportName"
                  name="gateInTransportName"
                  v-model="VehicleDetail.gateInTransportName"
                ></b-form-input>
              </md-layout>
                </md-layout>-->
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="30">
                  <md-input-container>
                    <label>Upload DO</label>
                    <md-file
                      placeholder="Click to Upload Images"
                      name="uploadDriverDoc"
                      id="uploadDriverDoc"
                      v-model="VehicleDetail.uploadDo"
                      @selected="onFileChange('Do')"
                      multiple
                    ></md-file>
                  </md-input-container>
                  <span class="error" v-if="!VehicleDetail.uploadDo">{{uploadImageError}}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="viewDocument.length>0">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="5" v-for="(item,index) in viewDocument" :key="index">
                  <a
                    :href="`${this.docURL}/doGateIn/`+item"
                    target="_blank"
                    download
                  >File - {{index+1}}</a>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label for="amountPaidYesNo">Amount Received(If Appilicable)</label>
                    <model-list-select
                      option-value="amountPaidYesNoV"
                      option-text="amountPaidYesNoT"
                      :list="amountPaidYesNoList"
                      placeholder="Select As Appilicable"
                      v-model="VehicleDetail.amountPaidYesNo"
                    ></model-list-select>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25" v-if="VehicleDetail.amountPaidYesNo=='Paid_In_Cash'">
                  <md-layout md-flex="100">
                    <label>Amount</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="cashAmount"
                      name="cashAmount"
                      v-model="VehicleDetail.cashAmount"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25" v-if="VehicleDetail.amountPaidYesNo=='Paid_In_Cash'">
                  <md-layout md-flex="100">
                    <label>Invoice/cheque No. (If Appilicable)</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="cashAmountInvoice"
                      name="cashAmountInvoice"
                      v-model="VehicleDetail.cashAmountInvoice"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="90">
                  <md-layout md-flex="100">
                    <label>Remarks</label>
                    <b-form-textarea :formatter="capitalizeAll" id="remarks" name="remarks" v-model="VehicleDetail.remarks"></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
            </div>
            <md-layout
              v-if="allContainerDetail.length>0"
              md-gutter
              class="mrgtop-button"
              style="margin-top:2%"
            >
              <md-layout md-flex="45"></md-layout>
              <md-layout md-flex="10">
                <b-button
                  variant="primary"
                  id="addButtonLoader"
                  :disabled="maintainenceId==''?false:true"
                  @click="addVehicleDetail"
                >Submit</b-button>
                <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop4"
      @close="onClose3"
    ></md-dialog-alert>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopDo"></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop3"
      @close="onClose3"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop11"
      @close="onClose3"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
      @close="onClose1"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <!-- <md-dialog-alert
  :md-content="alert.content"
  :md-ok-text="alert.ok"
  ref="addPop6"
   @close="onClose6" >
    </md-dialog-alert>-->
  </div>
</template>


<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Yard")) {
      this.$store.dispatch("setCurrentRoute", "/yard/GateIn");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      isLoading: false,
      ImpList: [
        {
          ImpVal: "Import",
          ImpText: "Import"
        },
        {
          ImpVal: "Export",
          ImpText: "Export"
        },
        {
          ImpVal: "EmptyMoment",
          ImpText: "Empty Moment"
        }
      ],
      containerConditionList: [
        {
          containerConditionV: "Dirty_Floor",
          containerConditionT: "Floor Dirty"
        },
        {
          containerConditionV: "Minor_Damage",
          containerConditionT: "Minor Damage"
        },
        {
          containerConditionV: "Heavy_Damage",
          containerConditionT: "Heavy Damage"
        }
      ],

      gateTypeList: [
        {
          gateTypeListV: "Vehicle_With_Container",
          gateTypeListT: "Vehicle With Container"
        },
        {
          gateTypeListV: "Empty_Vehicle",
          gateTypeListT: "Empty Vehicle"
        }
      ],

      amountPaidYesNoList: [
        {
          amountPaidYesNoV: "Paid_In_Cash",
          amountPaidYesNoT: "Paid In Cash/Cheque"
        },
        {
          amountPaidYesNoV: "NA",
          amountPaidYesNoT: "NA"
        }
      ],

      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      alert: {
        content:
          this.$sessionsStorage.get("editGateInId") != "" &&
          this.$sessionsStorage.get("editGateInId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      checked4: [],
      delaySurveyStatus: "",

      ContainerDetail: {
        containerGateInId: "",
        containerNo: "",
        containerTypeId: "",
        gateInType: "",
        transportName: "",
        tareWeight: "",
        manufractureYear: "",
        containerCondition: "",
        sealNo: "",
        remark: "",
        grossWeight: "",
        gateInId: "",
        vehicleNo: "",
        vehicleTruckId: "",
        uploadGateInCon: "",
        otherVehicle: "",
        doNumber: "",
        importStatus: "",
        vehcleArrivalDate: "",
        shippingId: "",
        arrivalFrom: "",
        doValidity: ""
      },

      maintainenceId: "",
      VehicleDetail: {
        gateInId: "",

        managerId: "",

        maintenanceRequest: "",
        delayReason: "",
        doValidity: "",
        uploadDo: "",
        doNumber: "",
        importStatus: "",
        vehcleArrivalDate: "",
        shippingId: "",
        arrivalFrom: "",
        shipperName: "",
        gateInTransportName: "",
        //  transportName: "",
        containerGateInId: "",
        gateInType: "",
        vehicleNo: "",
        amountPaidYesNo: "NA",
        cashAmount: "",
        cashAmountInvoice: "",
        remarks: "",
        bookingDate: "",
        bookingValidityShipping: ""
      },

      // remarkError: "",
      containerNoError: "",
      // doValidityError: "",
      containerTypeIdError: "",
      gateInTypeError: "",
      shippingIdError: "",
      tareWeightError: "",
      manufractureYearError: "",
      sameVehicleError: "",
      uploadImageError: "",
      // containerConditionError: "",
      //  sealNoError: "",
      //  vehcleArrivalDateError: "",
      transportNameError: "",
      arrivalFromError: "",
      vehicleNoError: "",
      grossWeightError: "",
      containerGateInIdError: "",
      sameContainerError: "",
      serviceDetails: {
        departmentId: "",
        serviceEstSeries: "",
        serviceEstimationDate: "",
        serviceEstimationId: "",
        maintenanceType: "",
        vehicleNo: "",
        vehicleYard: "",
        vehicleId: "",
        engineNo: "",
        chassisNo: "",
        yearOfPurchase: "",
        driverName: "",
        requestedBy: "",
        containerType: "",
        containerNo: "",
        department: "",
        itemForServiceEstId: "",
        approvedStatus: "",
        requestStatus: "",
        approvedBy: "",
        approvedById: "",
        addQuantityStatus: "",
        onRejectStatus: "",
        availableQuantity: ""
      },
      jobTypeMaster: [],
      serviceEstimationDateError: "",
      checkStatusApproval: "",
      itemModal: {
        itemForServiceEstId: "",
        serviceEstimationId: "",
        itemCode: "",
        itemName: "",
        itemNameCode: "",
        ratePerUnit: "",
        itemQuantity: "",
        totalAmount: "",
        quantityitem: "",
        itemId: "",
        approval: ""
      },
      total: "",
      tempVehicle: "czfsdfds",
      uploadGateInConError: "",

      itemMasterService: [],
      shippingDetailsNew: [],
      shippingDetails: [],

      validate: true,
      stockInDateError: "",
      // vehicleError1: "",
      //vehicleError2: "",
      addedByPersonError: "",
      // departmentError: "",
      poDateError: "",
      vendorNamError: "",
      goodsStatusError: "",
      qualityCheckError: "",
      maintenanceTypeError: "",
      itemNameError: "",
      ratePerUnitError: "",
      itemQuantityError: "",
      additemError: "",
      requestStatusError: "",

      stockReceivedDateError: "",
      lineDetailMaster: [],
      allvehicleDetail: [],
      locationMaster: [
        {
          pickupLocation: "mumbai"
        }
      ],
      containerMaster: [
        {
          pickupLocation: "mumbai"
        }
      ],
      vendorMaster: [],
      departmentMaster: [],
      itemCodeError: "",
      itemDetail: [{}],
      approvedStatus: [{}],

      vehicleDetail: [{}],
      locationDetail: [{}],
      containerDetail: [{}],
      gateInContainerDetail: [{}],

      dapartmentDetail: [],
      vendorDetail: [],
      allContainerDetail: [],
      designation: "",
      departmentName: "",
      notValid: true,
      errorItem: "",
      deleteID: "",
      errorNotApproved: "",
      otherVehicleError: "",

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editGateInId") != "" &&
          this.$sessionsStorage.get("editGateInId") != undefined
            ? "Update"
            : "Submit",
        FormVal:
          this.$sessionsStorage.get("editGateInId") != "" &&
          this.$sessionsStorage.get("editGateInId") != undefined
            ? "Update"
            : "Submit"
      }
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {
    //  this.JqueryFun();
  },
  watch: {
    VehicleDetail: {
      handler: function(newVal, oldVal) {
        if (this.vehicleDetail.shippingId != "") {
          let shippingValidityArry = this.lineDetailMaster.filter(x => {
            return x.shippingId == this.VehicleDetail.shippingId;
          });
        }
      },

      deep: true
    },
    ContainerDetail: {
      handler: function(newVal, oldVal) {
        if (this.ContainerDetail.containerTypeId != "") {
          let array1 = this.containerDetail.filter(x => {
            return x.containerType == this.ContainerDetail.containerTypeId;
          });

          this.ContainerDetail.grossWeight = array1[0].maxPayload;

          let array = [];
          if (array1[0].containerType == "2X20") {
            array = this.allvehicleDetail.filter(x => {
              return x.vehicleType.toLowerCase().includes("40".toLowerCase());
            });
          } else {
            array = this.allvehicleDetail;
          }

          this.vehicleDetail = array;
        }
        if (
          this.ContainerDetail.otherVehicle != "" &&
          this.ContainerDetail.otherVehicle != "Other Vehicle"
        ) {
          let arrayVehicle = this.allvehicleDetail.filter(x => {
            return x.regdNo == this.ContainerDetail.otherVehicle;
          });
          this.ContainerDetail.transportName = arrayVehicle[0].vehicleNo;
          this.ContainerDetail.vehicleTruckId = arrayVehicle[0].vehicleTruckId;
          this.tempVehicle = arrayVehicle[0].regdNo;
          this.ContainerDetail.vehicleNo = arrayVehicle[0].regdNo;
        }

        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerDetail.containerNo = newVal.containerNo.toUpperCase();
        }

        if (
          this.gateInContainerDetail.length > 0 &&
          this.ContainerDetail.containerGateInId == ""
        ) {
          let array = this.gateInContainerDetail.filter(x => {
            return (
              x.vehicleNo == this.ContainerDetail.vehicleNo &&
              x.vehicleStatus == 0
            );
          });
          if (array.length > 0) {
            this.sameVehicleError = "Vehicle  No. Already Exists in Gate-In";
            return false;
          } else {
            this.sameVehicleError = "";
          }
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (
      this.VehicleDetail.containerGateInId != "" &&
      (this.$sessionsStorage.get("editGateInId") == "" ||
        this.$sessionsStorage.get("editGateInId") == null)
    ) {
      this.delete33(this.VehicleDetail.containerGateInId);
    } else {
      this.$sessionsStorage.set("editGateInId", "");
    }
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {
    viewDocument() {
      return this.VehicleDetail.uploadDo != ""
        ? this.VehicleDetail.uploadDo.split(",")
        : [];
    },
    checkStatus() {
      return (this.checkStatusApproval =
        this.serviceDetails.approvedStatus == "Approved");
    },
    itemMasterList() {
      return this.itemDetail;
    },
    vehicleMasterList() {
      return this.vehicleDetail;
    },
    locationMasterList() {
      return this.locationMaster;
    },
    containerMasterList() {
      return this.containerMaster;
    }
  },
  methods: {
    removeCss() {
      $(".md-active").remove();
    },
    repairMaintain() {
      this.$router.push({
        path: "/yard/maintenance"
      });
    },
    onFileChange(id) {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }

      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/Api_Yard/uploadGateDo.php`, formData, config)
        .then(result => {
          if (id == "Do") {
            this.VehicleDetail.uploadDo = result.data;
          } else {
            this.ContainerDetail.uploadGateInCon = result.data;
          }
        })
        .catch(err => {
          throw err;
        });
    },

    checkContainer() {
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      if (!containerformat.test(this.ContainerDetail.containerNo)) {
        this.sameContainerError = "Enter Valid Format";
      } else if (
        this.gateInContainerDetail.length > 0 &&
        this.ContainerDetail.containerGateInId == ""
      ) {
        let array = this.gateInContainerDetail.filter(x => {
          return (
            x.containerNo == this.ContainerDetail.containerNo &&
            x.containerStatus == 0
          );
        });

        if (array.length > 0) {
          this.sameContainerError = "Container No. Already Exists";
          return false;
        } else {
          this.sameContainerError = "";
        }
      }
    },

    delete33(id) {
      let vehicle_drive = {
        delete: id
      };

      let currentDate = new Date();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/deleteNullValue.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    checkVehicle() {},
    doAlert() {
      var currentDate = new Date();
      var doValidity = this.VehicleDetail.doValidity;
      if (doValidity < currentDate) {
        this.alert.content = "Note :- Your DO Validity has Expired ..!";
        this.$refs["addPopDo"].open();
      }
    },

    deleteData(ServiceEstitemID) {
      this.deleteID = ServiceEstitemID;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },
    showShippinhgID(id) {
      let array = this.shippingDetails.filter(x => {
        return x.shippingId == id;
      });

      this.shippingDetailsNew = array;
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "yard_gateincontainer",
          tableId: "containerGateInId",
          tableVal: this.deleteID
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              // this.JqueryFun();

              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    viewModalPage(itemID) {
      let array = this.allContainerDetail.filter(x => {
        return x.containerGateInId == itemID;
      });

      Object.keys(this.ContainerDetail).map(x => {
        this.ContainerDetail[x] = array[0][x] || "";
      });

      // this.openItemDialog();
    },
    onClose3(type) {
      this.$router.push({
        path: "/yard/viewGateIn"
      });
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#gateInContainer").DataTable();
    //   });
    // },
    findItemCode(item) {
      this.itemModal.ratePerUnit = item.ratePerUnit;
      this.itemModal.itemName = item.itemName;
      this.itemModal.itemCode = item.itemCode;
      this.itemModal.itemId = item.itemId;
    },

    jobType() {
      this.$router.push({
        path: "/jobOrderSheet/jobOrderSheet"
      });
    },

    getData() {
      this.isLoading = true;
      let vehicle_drive = {
        itemCode: "itemCode",
        gateInId: this.$sessionsStorage.get("editGateInId")
      };

      let currentDate = new Date();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/fetchToGateIn.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.vehicleDetail = data.vehicleDetail;
            this.allvehicleDetail = data.vehicleDetail;

            this.departmentName = data.UserDetail[0].departmentName;

            this.designation = data.UserDetail[0].designation;

            if (data.gateInContainer.length > 0) {
              this.gateInContainerDetail = data.gateInContainer;
            } else {
              this.gateInContainerDetail = [];
            }
            if (data.containerMaster.length > 0) {
              this.containerDetail = data.containerMaster;
            } else {
              this.containerDetail = [];
            }
            if (data.lineDetail.length > 0) {
              this.lineDetailMaster = data.lineDetail;
            } else {
              this.lineDetailMaster = [];
            }

            this.shippingDetails = data.yard_containercondition;
            if (this.VehicleDetail.shippingId != "") {
              this.showShippinhgID(this.VehicleDetail.shippingId);
            }

            if (data.maintainenceRepair.length > 0) {
              this.maintainenceId = data.maintainenceRepair[0].maintainenceId;
              this.$sessionsStorage.set(
                "editMaintainenceRepId",
                data.maintainenceRepair[0].maintainenceId
              );
            } else {
              this.$sessionsStorage.set("editMaintainenceRepId", "");
            }

            if (
              this.$sessionsStorage.get("editGateInId") == "" ||
              this.$sessionsStorage.get("editGateInId") == null
            ) {
              this.ContainerDetail.vehcleArrivalDate = this.formatDate(
                currentDate
              );
            } else {
            }

            if (
              this.$sessionsStorage.get("editGateInId") != "" &&
              this.$sessionsStorage.get("editGateInId") != undefined
            ) {
              this.viewEditServiceEstimation();
              // this.showServiceEst();
            }
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");
      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },
    onClose(type) {
      this.$router.push({
        path: "/yard/viewGateIn"
      });
    },
    approvalRequest() {
      let client_detail = {
        approvedBy: "approvedBy"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/serviceApprovalRequest.php`,
        data: JSON.stringify(client_detail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
        })
        .catch(error => {});
    },

    validateJobOrder() {
      let validate_new = true;

      // if (this.VehicleDetail.vehcleArrivalDate == "") {
      //   $("#vehcleArrivalDate").focus();
      //   this.vehcleArrivalDateError = "Select Arrival Date";
      //   validate_new = false;
      // }
      if (this.ContainerDetail.gateInType == "") {
        $("#gateInType").focus();
        this.gateInTypeError = "Select Gate-In Type";
        validate_new = false;
      }
      if (this.containerDetail.gateInType == "Vehicle_With_Container") {
        // if (this.VehicleDetail.arrivalFrom == "") {
        //   $("#arrivalFrom").focus();
        //   this.arrivalFromError = "Enter Arrival From";
        //   validate_new = false;
        // }
        // if (this.VehicleDetail.transportName == "") {
        //   this.transportNameError = "Enter Transport Name ";
        //   validate_new = false;
        // }
        // if (this.VehicleDetail.shippingId == "") {
        //   this.shippingIdError = "Enter Line/SC ";
        //   validate_new = false;
        // }
        if (this.VehicleDetail.uploadDo == "") {
          this.uploadImageError = "Upload Atleast 1 Image ";
          validate_new = false;
        }
      }
      if (this.VehicleDetail.containerGateInId == "") {
        this.containerGateInIdError = "Add atleast One Container ";
        validate_new = false;
      }
      // if (this.VehicleDetail.doValidity == "") {
      //   this.doValidityError = "Select Do Validity ";
      //   validate_new = false;
      // }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateModal() {
      let validate_new = true;
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      if (this.ContainerDetail.containerNo == "") {
        $("#containerNo").focus();
        this.containerNoError = "Enter Container No.";
        validate_new = false;
      } else {
        if (containerformat.test(this.ContainerDetail.containerNo)) {
          this.sameContainerError = "";
        } else {
          this.sameContainerError = "Enter Valid Format";
          validate_new = false;
        }
      }

      if (this.ContainerDetail.uploadGateInCon == "") {
        this.uploadGateInConError = "Select File";
        validate_new = false;
      } else {
      }
      if (this.ContainerDetail.containerTypeId == "") {
        $("#containerTypeId").focus();
        this.containerTypeIdError = "Enter Container type";
        validate_new = false;
      }
      if (this.ContainerDetail.vehicleNo == "") {
        $("#vehicleNo").focus();
        this.vehicleNoError = "Enter OtherVehicle Number ";
        validate_new = false;
      }

      if (this.ContainerDetail.otherVehicle == "") {
        $("#vehicleNo").focus();
        this.otherVehicleError = "Enter Vehicle Number ";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addContainer() {
      if (this.VehicleDetail.gateInId != "") {
        this.ContainerDetail["gateInId"] = this.VehicleDetail.gateInId;
      } else {
        this.ContainerDetail["gateInId"] = "";
      }
      if (
        this.gateInContainerDetail.length > 0 &&
        this.ContainerDetail.containerGateInId == "" &&
        this.ContainerDetail.gateInType == "Vehicle_With_Container"
      ) {
        let array = this.gateInContainerDetail.filter(x => {
          return (
            x.containerNo == this.ContainerDetail.containerNo &&
            x.containerStatus == 0
          );
        });

        if (array.length > 0) {
          this.sameContainerError = "Container No. Already Exists";
          return false;
        } else {
          this.sameContainerError = "";
        }
      }

      if (this.ContainerDetail.gateInType == "") {
        $("#gateInType").focus();
        this.gateInTypeError = "Select Gate-In Type";
        return false;
      }

      if (this.ContainerDetail.otherVehicle == "") {
        $("#otherVehicle").focus();

        this.otherVehicleError = "Enter Vehicle Number ";

        return false;
      }

      if (this.ContainerDetail.gateInType == "Vehicle_With_Container") {
        // this.checkContainer();
        this.validateModal();
      }

      if (this.validate != false && this.sameVehicleError == "") {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/addGateInContainer.php`,
          data: JSON.stringify(this.ContainerDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              if (data.msg != "Updated Successfully") {
                this.VehicleDetail.containerGateInId += data.Id + ",";

                this.alert.content = "Added Succesfully";
              } else {
                this.alert.content = "Data updated Succesfully";
              }
              this.$refs["addPop1"].open();
              Object.keys(this.ContainerDetail).map(x => {
                if (
                  x == "containerTypeId" &&
                  this.ContainerDetail.containerTypeId == "2X20"
                ) {
                } else if (
                  x == "vehicleNo" &&
                  this.ContainerDetail.containerTypeId == "2X20"
                ) {
                } else if (x != "gateInType") {
                  this.ContainerDetail[x] = "";
                }
              });

              this.getData();

              // this.remarkError = "";
              this.containerNoError = "";
              this.shippingIdError = "";
              this.containerTypeIdError = "";
            }
          })

          .catch(error => {});
      }
    },

    onClose1(type) {
      let payload = {
        containerGateInId: this.VehicleDetail.containerGateInId
      };
      if (this.VehicleDetail.gateInId != "") {
        payload["gateInId"] = this.VehicleDetail.gateInId;
      } else {
        payload["gateInId"] = "";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewGateInContainer.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.allContainerDetail = data.itemArray;
            }

            (this.itemModal.itemCode = ""),
              //  (this.itemModal.itemId = ""),
              (this.itemModal.itemName = ""),
              (this.itemModal.itemQuantity = ""),
              (this.itemModal.ratePerUnit = ""),
              (this.itemNameError = ""),
              (this.itemQuantityError = "");
            this.ratePerUnitError = "";

            //this.$refs["dialog"].open();
            // this.$refs["addPop1"].close();
          }
        })
        .catch(error => {});
    },

    viewEditServiceEstimation() {
      let edit_SE = {
        editClient: "editClient",
        gateInId: this.$sessionsStorage.get("editGateInId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewEditGateIn.php`,
        data: JSON.stringify(edit_SE),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            Object.keys(data.editClient[0]).map(x => {
              this.VehicleDetail[x] = data.editClient[0][x] || "";
            });

            if (data.editClient[0].delaySurveyStatus == 1) {
              this.maintainenceId = 1;
              this.delaySurveyStatus = 1;
            }

            this.VehicleDetail.containerGateInId += ",";
            this.ContainerDetail.gateInType = this.VehicleDetail.gateInType;

            this.showServiceEst(this.VehicleDetail.containerGateInId);
          }
        })
        .catch(error => {});
    },
    showServiceEst(serviceid) {
      this.allContainerDetail = [];

      let payload = {
        containerGateInId: serviceid,
        gateInId: ""
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewGateInContainer.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.allContainerDetail = data.itemArray;
            }
            // this.JqueryFun();
            // this.$refs["addPop1"].close();
          }
        })
        .catch(error => {});
    },

    itemMasterFilter(list, query) {
      return this.itemDetail.filter(x => {
        return x.itemNameCode.toLowerCase().includes(query.toLowerCase());
      });
    },
    finalAmount() {
      let amount =
        parseFloat(this.itemModal.ratePerUnit) *
        parseFloat(this.itemModal.itemQuantity);
      this.itemModal.totalAmount = amount;
    },

    vehicleMasterFilter(list, query) {
      return this.vehicleDetail.filter(x => {
        return x.regdNo.toLowerCase().includes(query.toLowerCase());
      });
    },

    locationMasterFilter(list, query) {
      return this.locationMaster.filter(x => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
    },
    containerMasterFilter(list, query) {
      return this.containerDetail.filter(x => {
        return x.containerType.toLowerCase().includes(query.toLowerCase());
      });
    },

    previousVendorView() {
      this.$router.push({
        path: "/yard/viewGateIn"
      });
    },

    addVehicleDetail() {
      this.validateJobOrder();

      if (this.validate != false) {
        this.VehicleDetail["gateInType"] = this.ContainerDetail.gateInType;
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/addGateIn.php`,
          data: JSON.stringify(this.VehicleDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");
              this.$refs["addPop3"].open();
            }
          })
          .catch(error => {});
      }
    },
    requestForMaintain(userstatus) {
      this.VehicleDetail["gateInType"] = this.ContainerDetail.gateInType;
      if (userstatus == "employee") {
        this.VehicleDetail["maintenanceRequest"] = "Sent For Approval";
      }
      this.VehicleDetail["userstatus"] = userstatus;
      $("#addButtonLoader3").css("display", "none");
      $("#loader3").css("display", "block");
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/addGateIn.php`,
        data: JSON.stringify(this.VehicleDetail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            $("#loader3").css("display", "none");
            $("#addButtonLoader3").css("display", "block");
            this.alert.content = "Request Sent For Approval";
            this.$refs["addPop11"].open();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 25% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  margin-top: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
  border: 0px;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}
.md-select-content {
  z-index: 999999999;
}
.back {
  margin-top: 8px;
}
</style>


// WEBPACK FOOTER //
// GateIn.vue?86b735d6